module.exports = __webpack_public_path__ + "media/components/brandings/svgs/email/branding-email-links-549db4ef927a63705a22d2c1d4e549fc.svg";